import { Step, StepConnector, StepLabel, Stepper } from '@mui/material';
import { useStyles } from './style';
import StepIcon from './StepIcon';

interface Props {
  activeStep: number;
  steps: steps[];
}

export enum stepType {
  success,
  error,
}

type steps = {
  title: string;
  type: stepType;
};

const SimpleStepper = ({ activeStep, steps }: Props) => {
  const classes = useStyles();

  return (
    <Stepper
      className={classes.stepper}
      activeStep={activeStep}
      alternativeLabel
      connector={
        <StepConnector
          className={classes.stepConnector}
          classes={{
            line: classes.stepConnectorActive,
          }}
        />
      }>
      {steps.map((step) => (
        <Step key={step.title}>
          <StepLabel
            error={step.type === stepType.error}
            className={
              step.type === stepType.error
                ? classes.stepLabelError
                : classes.stepLabel
            }
            StepIconComponent={StepIcon}>
            {step.title}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default SimpleStepper;
